
// 为减低广告组件的耦合性，campaign、group应只存储id和name，其余属性应调用接口获取详细信息

export const adStore = {
  SP: {
    isAdsAuth: true, // 站点是否授权广告
    marketId: null,
    market: null,
    currencySymbol: null,
    rootMountEl: null,
    portfolios: [],
    campaign: null,
    group: null,
    campaignDate: null,
    groupDate: null,
    defaultBid:null,// 默认竞价
  },
  SD: {
    isAdsAuth: true, // 站点是否授权广告
    marketId: null,
    market: null,
    currencySymbol: null,
    rootMountEl: null,
    portfolios: [],
    campaign: null,
    group: null,
    campaignDate: null,
    groupDate: null,
    defaultBid:null,// 默认竞价
  },
  SB: {
    isAdsAuth: false, // 站点是否授权广告
    isBrand: -2, // 站点是否有品牌 -1：正在校验 0:无品牌无数据 1：有品牌 2：无品牌有数据
    marketId: null,
    market: null,
    currencySymbol: null,
    rootMountEl: null,
    portfolios: [],
    campaign: null,
    group: null,
    campaignDate: null,
    groupDate: null,
    defaultBid:null,// 默认竞价
  }
};
